<template>
  <v-dialog
      width="950"
      :value="dialogs.prolongPlan"
      :overlay-opacity="0.9"
      content-class="payment-dialog"
      :scrollable="false"
      @click:outside="closeDialog"
      @keydown.esc="closeDialog"
  >
    <v-card
       class="payment-card"
       max-height="850"
       min-height="675"
    >
      <div class="payment-left-select-side" :style="{ overflowY: isOverflow()}">
        <!-- ЗАГАЛОВОК -->
        <div class="payment-from-trial-dialog-title payment-card-title">
          {{ $t('plans.prolongPlan') }}
          <span class="plan-name-text">
            {{ currentPlanName }}
          </span>
        </div>

        <div class="payment-info-wrapper">
          <div class="d-flex align-center justify-space-around">
            <!-- АККАУНТ -->
            <div class="payment-info-account flex-grow-1">
              <div class="payment-info-title-text">
                {{ $t('common.account') }}
              </div>
              <div class="payment-info-value-text">
                {{ profile.username }}
              </div>
            </div>

            <!-- КОЛИЧЕСВО ВАШИХ ПРОФИЛЕЙ -->
            <div class="payment-info-top-profiles-count flex-grow-1">
              <div class="payment-info-title-text">
                {{ $t('plans.yourProfilesCount') }}
              </div>
              <div class="payment-info-value-text">
                {{ paymentInfo.profilesCount }}
              </div>
            </div>
          </div>

          <!-- ДОПОЛНИТЕЛЬНЫЕ ПРОФИЛИ -->
          <div class="payment-info-profiles-count">
            <div class="payment-info-profiles-count-title">
              <div class="payment-info-title-text">
                {{ $t('plans.additionalProfiles') }}
              </div>

              <span class="payment-info-extra-profiles-available">
                {{ $t('plans.willBeAvailableProfiles', [paymentInfo.profilesCount]) }}
              </span>
            </div>

            <div class="payment-info-extra-profiles-select">
              <dolphin-select :options="[paymentInfo.additionalProfiles]" :disabled="true" :default="paymentInfo.additionalProfiles" />
            </div>
          </div>

          <!-- ДОПОЛНИТЕЛЬНЫЕ ПОЛЬЗОВАТЕЛИ -->
          <payment-dialog-extra-users :disabled="true" />

          <!-- ПЕРИОД ОПЛАТЫ -->
          <payment-dialog-prolong-months />

          <!-- СПОСОБ ОПЛАТЫ -->
          <payment-dialog-payment-methods v-if="showPaymentMethods" ref="paymentMethods" :estimate="estimate" />

          <!-- ВЫВОД ОШИБОК -->
          <v-alert
              v-if="error.show"
              color="error"
              text
              class="mb-0 mt-4 mb-4"
          >
            {{ error.message }}
          </v-alert>

          <!-- ИНФОРМАЦИЯ О КОМПАНИИ -->
          <payment-dialog-company-info
            v-if="showPaymentDialogCompanyInfo"
            :renew="true"
          />
        </div>
      </div>

      <!-- К ОПЛАТЕ -->
      <payment-dialog-summary
        :estimate="estimate"
        :pay="pay"
        :handle-promo-apply="handlePromoApply"
        :pay-loading="payLoading"
        :promocode-loading="promocodeLoading"
        :renew="true"
      />

      <!-- КНОПКА ЗАКРЫТЬ -->
      <div
          class="payment-close-button"
          @click="closeDialog"
      >
        <v-icon
            :size="18"
            color="gray"
        >
          mdi-close
        </v-icon>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters } from "vuex";
  import { mapFields } from "vuex-map-fields";
  import { capitalizeText } from "@/utils/helpers";
  import paymentMixin from '@/mixins/payment';
  import PaymentDialogExtraUsers from "@/components/plans/dialogs/components/PaymentDialogExtraUsers";
  import PaymentDialogProlongMonths from "@/components/plans/dialogs/components/PaymentDialogProlongMonths";
  import PaymentDialogPaymentMethods from "@/components/plans/dialogs/components/paymentMethods/PaymentDialogPaymentMethods";
  import PaymentDialogSummary from "@/components/plans/dialogs/components/PaymentDialogSummary";
  import PaymentDialogCompanyInfo from "@/components/plans/dialogs/components/PaymentDialogCompanyInfo";
  import DolphinSelect from "@/components/custom/DolphinSelect";
  import {
    PAYMENT_METHOD_CAPITALIST_NAME,
    PAYMENT_METHOD_CARD_NAME,
    PAYMENT_METHOD_CRYPTO_NAME,
    PAYMENT_METHOD_CRYPTOMUS_NAME,
    PAYMENT_METHOD_CLOUDPAYMENTS_NAME,
    PAYMENT_METHOD_FREEKASSA_NAME,
    PAYMENT_METHOD_INXY_NAME,
    PAYMENT_METHOD_UNLIMINT_NAME,
    PAYMENT_METHOD_USDT_NAME,
    PAYMENT_METHOD_WALLET_NAME,
    PAYMENT_METHOD_STRIPE
  } from '@/constants/plans'

  export default {
    name: 'ProlongPlanDialog',

    components: {
      PaymentDialogExtraUsers,
      PaymentDialogProlongMonths,
      PaymentDialogPaymentMethods,
      PaymentDialogSummary,
      PaymentDialogCompanyInfo,
      DolphinSelect
    },

    mixins: [
      paymentMixin
    ],

    data () {
      return {
        estimate: 0,
        error: {
          show: false,
          message: ''
        },
        PAYMENT_METHOD_CARD_NAME,
        PAYMENT_METHOD_UNLIMINT_NAME,
        PAYMENT_METHOD_STRIPE,
        payLoading: false,
        promocodeLoading: false,
        capitalistInterval: 0,
        unlimintInterval: 0,
        cryptoInterval: 0,
        usdtInterval: 0,
      }
    },

    computed: {
      ...mapGetters({
        dialogs: 'plans/dialogs',
        paymentInfo: 'plans/paymentInfo',
        profile: 'main/profile',
        countryCode: 'plans/countryCode',
        isLocalCard: 'plans/isLocalCard',
        promocodeState: 'plans/promocodeState',
        paymentSummary: 'plans/paymentSummary',
        dontShowPaymentLeftSideScroll: 'plans/dontShowPaymentLeftSideScroll'
      }),
      ...mapFields('main', ['queryParamPromo']),
      ...mapFields('plans', ['invoice']),
      currentPlanName () {
        const { plan, isCustomTariff } = this.profile.subscription

        return isCustomTariff ?
          this.$t(`plans.${plan}.${plan}Custom`) :
          capitalizeText(this.paymentInfo.plan)
      },
      showPaymentMethods () {
        return this.paymentSummary.total > 0
      }
    },

    watch: {
      countryCode: {
        deep: true,

        async handler () {
          await this.$store.dispatch('plans/setIsLocalCard', this.countryCode === "RU")
        }
      }
    },

    async created () {
      this.$set(this.error, 'show', false)
      this.$set(this.error, 'message', '')

      this.payLoading = true

      await this.api.get('/subscription/renew').then(res => {
        const data = res.data.data
        const prolongMonths = data.days ? Math.max(1, Math.floor(data.days / 30)) : 1
        const discount = (prolongMonths >= 12) ? 40 : ((prolongMonths >= 6) ? 20 : 0)
        const updatedPaymentInfo = {
          promocode: data.promo.name,
          discount,
          prolongMonths,
          usersLimit: data.users.limit,
          profilesLimit: data.browserProfiles.limit,
          additionalUsers: data.users.additionalUsers,
          additionalProfiles: data.browserProfiles.additionalProfiles,
          countForCurrentMonth: data.browserProfiles.countForCurrentMonth,
          limitForCurrentMonth: data.browserProfiles.limitForCurrentMonth,
          isCustomTariff: data.isCustomTariff || false
        }

        if (this.renewSecondMonthWithDiscount) {
          updatedPaymentInfo.prolongMonths = 1
        }

        this.$store.dispatch('plans/updatePaymentInfo', updatedPaymentInfo)
      }).finally(() => {
        this.payLoading = false
      })

      await this.$store.dispatch('plans/setIsLocalCard', this.countryCode === "RU")
    },

    methods: {
      capitalizeText,

      isOverflow() {
        return this.dontShowPaymentLeftSideScroll && !this.showPaymentMethods ? 'unset' : 'auto';
      },

      async closeDialog () {
        await this.$store.dispatch('plans/reloadPaymentInfo')

        await this.$store.dispatch('main/setRenewSecondMonthWithDiscount', false)
        await this.$store.dispatch('plans/closeDialog', 'prolongPlan')

        if (this.unlimintInterval) {
          clearInterval(this.unlimintInterval)
        }

        if (this.cryptoInterval) {
          clearInterval(this.cryptoInterval)
        }

        if (this.usdtInterval) {
          clearInterval(this.usdtInterval)
        }

        if (this.capitalistInterval) {
          clearInterval(this.capitalistInterval)
        }
      },

      async pay () {
        try {
          this.payLoading = true

          await this.$store.dispatch('plans/clearPromo')

          this.$set(this.error, 'show', false)
          this.$set(this.error, 'message', '')

          const invoiceResponse = await this.$store.dispatch('plans/createPaymentRenewInvoice')

          if (
            invoiceResponse &&
            invoiceResponse.status === 200 &&
            invoiceResponse.data?.data &&
            invoiceResponse.data.data.invoiceId &&
            invoiceResponse.data.data.currency &&
            invoiceResponse.data.data.provider
          ) {
            try {
              this.$metrika.reachGoal('payment')
            } catch (e) {
              console.error(e)
            }
            this.successfulPaymentAlert = false

            switch (this.paymentInfo.paymentMethod) {
              case PAYMENT_METHOD_CARD_NAME:
                if (invoiceResponse.data.data.provider === PAYMENT_METHOD_CLOUDPAYMENTS_NAME) {
                  const { invoiceId, sum, currency } = invoiceResponse.data.data;

                  this.openCloudPaymentsWidget(
                    invoiceId.toString(),
                    sum,
                    currency,
                    this.closeDialog
                  )
                } else if (invoiceResponse.data.data.provider === PAYMENT_METHOD_FREEKASSA_NAME) {
                  const { freeKassaPaymentUrl } = invoiceResponse.data.data
                  window.open(freeKassaPaymentUrl, '_blank')
                }
                break;
              case PAYMENT_METHOD_UNLIMINT_NAME:
                window.open(invoiceResponse.data.data.unlimintPaymentUrl,'_self');
                this.unlimintInterval = this.setPaymentInterval(this.unlimintInterval, invoiceResponse.data.data.invoiceId, this.closeDialog)
                break;
              case PAYMENT_METHOD_STRIPE:
                window.open(invoiceResponse.data.data.stripePaymentUrl,'_blank');
                break;
              case PAYMENT_METHOD_CRYPTO_NAME:
                if (invoiceResponse.data.data.provider === PAYMENT_METHOD_CRYPTOMUS_NAME) {
                  window.open(invoiceResponse.data.data.cryptomusPaymentUrl, '_blank');
                } else if (invoiceResponse.data.data.provider === PAYMENT_METHOD_INXY_NAME) {
                  window.open(invoiceResponse.data.data.inxyPaymentUrl, '_blank');
                }
                break;
              case PAYMENT_METHOD_CAPITALIST_NAME:
                this.capitalistInterval = this.setPaymentInterval(this.capitalistInterval, invoiceResponse.data.data.invoiceId, this.closeDialog)
                await this.$nextTick()
                this.$refs.paymentMethods.$refs.capitalist.submit()
                break;
              case PAYMENT_METHOD_USDT_NAME:
                if (invoiceResponse.data.data.provider === PAYMENT_METHOD_CRYPTOMUS_NAME) {
                  window.open(invoiceResponse.data.data.cryptomusPaymentUrl,'_blank')
                  this.usdtInterval = this.setPaymentInterval(this.usdtInterval, invoiceResponse.data.data.invoiceId, this.closeDialog)
                } else if (invoiceResponse.data.data.provider === PAYMENT_METHOD_INXY_NAME) {
                  window.open(invoiceResponse.data.data.inxyPaymentUrl, '_blank');
                }
                break;
              case PAYMENT_METHOD_WALLET_NAME:
                if (invoiceResponse.data.data.provider === PAYMENT_METHOD_CAPITALIST_NAME) {
                  this.capitalistInterval = this.setPaymentInterval(this.capitalistInterval, invoiceResponse.data.data.invoiceId, this.closeDialog)
                  await this.$nextTick()
                  this.$refs.paymentMethods.$refs.capitalist.submit()

                  break;
                } else {
                  this.$refs.paymentMethods.$refs.paymentTarget.action = invoiceResponse.data.data.unlimintPaymentUrl;
                  this.$refs.paymentMethods.$refs.paymentTarget.submit();
                  this.unlimintInterval = this.setPaymentInterval(this.unlimintInterval, invoiceResponse.data.data.invoiceId, this.closeDialog)

                  break;
                }
            }
          } else {
            console.log(invoiceResponse, 'Invoice response')
          }
        } catch (e) {
          const error = e.response

          if (error.status === 500) {
            this.$set(this.error, 'show', true)
            this.$set(this.error, 'message', this.$t('plans.errors.somethingWentWrong'))
          } else if (error.data && error.data.error && error.data.error.code) {
            this.$set(this.error, 'show', true)

            if (error.data.error.text === 'This promo is not valid') {
              this.$set(this.error, 'message', this.$t(`plans.errors.E_INVALID_PROMO`))
              this.promocodeState.status = 'error'
            } else {
              this.$set(this.error, 'message', this.$t(`plans.errors.${error.data.error.code}`))
            }
          }
        } finally {
          this.payLoading = false
        }
      },

      async handlePromoApply (value) {
        this.paymentInfo.promocode = value
        this.promocodeLoading = true

        try {
          const response = await this.$store.dispatch('plans/checkPromocode', value)

          if (response.status === 200 && response.data?.data) {
            const { data } = response.data

            const promocodeState = {
              status: 'success',
              discount: data.discount,
              errorText: ''
            }

            if (data.discount === 0) {
              promocodeState.status = 'error'

              if (data.discount === 0 && this.profile.team.usedPromo) {
                promocodeState.errorText = 'promoForFirstPayment'
              } else {
                promocodeState.errorText = 'promoLimitExceed'
              }
            }

            await this.$store.dispatch('plans/setPromocodeState', promocodeState)
          } else {
            await this.$store.dispatch('plans/setPromocodeState', {
              status: 'error',
              discount: 0,
              errorText: ''
            })
          }
        } catch (e) {
          await this.$store.dispatch('plans/setPromocodeState', {
            status: 'error',
            discount: 0,
            errorText: ''
          })
        } finally {
          this.promocodeLoading = false
        }
      }
    }
  }
</script>

<style>

</style>
